/**
 * Which video plays (VIDEO_PLAN §12, from Kurtis's phone test): among the
 * candidates at least half visible, the one whose media is nearest the
 * centre of the viewport. NOT the first to become visible — that rule played
 * the card entering from below while the centred one was still on screen.
 *
 * Pure: the caller measures (getBoundingClientRect) and decides when
 * (once scrolling settles). Ties go to the earlier candidate.
 *
 * @param {Array<{ id: any, rect: { top, bottom, left, right } }>} candidates
 * @param {{ top, bottom, left, right }} viewport
 * @param {number} [minVisible=0.5] - the fraction of a candidate's area on screen
 * @returns {any|null} the winner's id
 */
export function visibleFraction(rect, viewport) {
  const width = rect.right - rect.left;
  const height = rect.bottom - rect.top;
  if (width <= 0 || height <= 0) return 0;
  const w = Math.max(0, Math.min(rect.right, viewport.right) - Math.max(rect.left, viewport.left));
  const h = Math.max(0, Math.min(rect.bottom, viewport.bottom) - Math.max(rect.top, viewport.top));
  return (w * h) / (width * height);
}

export function pickCentre(candidates, viewport, minVisible = 0.5) {
  const cx = (viewport.left + viewport.right) / 2;
  const cy = (viewport.top + viewport.bottom) / 2;
  let best = null;
  let bestDistance = Infinity;
  for (const { id, rect } of candidates) {
    if (visibleFraction(rect, viewport) < minVisible) continue;
    const dx = (rect.left + rect.right) / 2 - cx;
    const dy = (rect.top + rect.bottom) / 2 - cy;
    const distance = dx * dx + dy * dy;
    if (distance < bestDistance) {
      best = id;
      bestDistance = distance;
    }
  }
  return best;
}
